<template>
  <va-card>
    <div class="row">
      <div class="flex md4 sm6 xs12">
        <va-input readonly v-model="item.account_name" label="Account" />
      </div>
    </div>
    <div class="row">
      <div class="flex md4 sm6 xs12">
        <va-input v-model="item.first_name" label="First name" />
      </div>
      <div class="flex md4 sm6 xs12">
        <va-input v-model="item.last_name" label="Last name" />
      </div>
    </div>
    <div class="row">
      <div class="flex md4 sm6 xs12">
        <va-input v-model="item.password" label="Password (leave blank for no change)" />
      </div>
    </div>
    <div class="row">
      <div class="flex md4 sm6 xs12">
        <va-input v-model="item.email" type="email" label="Email"> </va-input>
      </div>
      <div class="flex md4 sm6 xs12">
        <span>Last logged in: {{ this.item.date_last_login }}</span>
      </div>
    </div>
    <div class="row">
      <va-checkbox label="Admin" v-model="item.is_admin" />
    </div>
    <div class="row">
      <va-checkbox label="Enabled" v-model="item.enabled" />
    </div>
    <div class="row">
      <va-button @click="mainSave" :disabled="!hasDataChanged">Save</va-button>
      <va-button @click="mainCancel" :disabled="!hasDataChanged">Cancel</va-button>

      <span v-if="showSaving" class="notif">Saving...</span>
      <span v-if="showSaved" class="notif">Saved</span>
      <span v-if="showChangesWarning" class="notif" style="color: red">Save or Cancel changes before selecting another user</span>
    </div>

    <va-modal v-model="showConfirmModal" :noOutsideDismiss="true" :hideDefaultActions="true" title="Save Changes">
      <p>Do you want to save the changes?</p>

      <template slot="actions">
        <va-button @click="confirmSave">Yes</va-button>
        <va-button @click="cancelSave">No</va-button>
      </template>
    </va-modal>
  </va-card>
</template>

<script>
import hiqapi from '@/hiqapi/hiqapi'

export default {
  data() {
    return {
      loading: false,
      item: {
        account_name: '',
        date_created: '',
        date_last_login: '',
        date_updated: '',
        email: '',
        enabled: false,
        first_name: '',
        password: '',
        id: '',
        is_admin: false,
        item_id: '',
        last_name: '',
      },
      itemOrig: null,
      showConfirmModal: false,
      showChangesWarning: false,
      showSaving: false,
      showSaved: false,
    }
  },
  computed: {

    csvDisabled() {
      return this.listData.length === 0
    },
    hasDataChanged() {
      if (!this.itemOrig) {
        return false
      }
      for (let key of Object.keys(this.itemOrig)) {
        if (this.itemOrig[key] !== this.item[key]) {
          return true
        }
      }
      return false
    },
  },

  methods: {
    async mainSave() {
      console.log('YES, SAVE', this.item)
      this.showChangesWarning = false
      this.showSaving = true
      let resp = await hiqapi.postPutWait('put', '/users/' + this.item.id, this.item)
      this.showSaving = false

      console.log('BACK resp=', resp)

      if (resp.status !== 200) {
        console.log(resp)
        this.showToast(`Error: ${resp.data.message}`, {
          position: 'top-center',
          duration: 6000,
        })

        return
      }
      this.showSaved = true
      setTimeout(() => (this.showSaved = false), 2000)

      this.itemOrig = { ...this.item }
      this.reloadUserList()
    },

    mainCancel() {
      console.log('NO SAVE')
      this.showChangesWarning = false

      this.item = { ...this.itemOrig }
    },

    async confirmSave() {
      console.log('YES, SAVE', this.item)

      let resp = await hiqapi.postPutWait('put', '/users/' + this.item.id, this.item)
      console.log('BACK resp=', resp)

      if (resp.status !== 200) {
        this.passwordErrors = ['Incorrect email or password']
        return
      }

      this.showConfirmModal = false
      this.reloadUserList()
    },

    cancelSave() {
      console.log('NO SAVE')
      this.showConfirmModal = false
    },

    reloadUserList() {
      this.$root.$emit('reload_user_list', null, null)
    },
  },

  mounted() {
    this.$root.$on('user_selected', (arg1, arg2) => {
      if (this.hasDataChanged) {
        this.showChangesWarning = true
        return
      }
      this.showChangesWarning = false

      this.itemOrig = arg1
      this.item = { ...arg1 }
      console.log('UD Message received: ', arg1, arg2)

      console.log('itemOrig ===> ', this.itemOrig)
    })
  },
}
</script>

<style scoped>
.notif {
  align-self: center;
  padding-left: 40px;
}
</style>
